import FormElementMixin from '../mixins/FormElementMixin.js';
import FormElementAutocompleteMixin from "../mixins/FormElementAutocompleteMixin";

Vue.asyncComponent('ak-autocomplete-in-modal', {
    mixins: [FormElementAutocompleteMixin],
    props: {
        filterMethode: {
            required: false,
        },
        minCharCount: {
            type: Number,
            required: false,
            default: 0
        },
        modalWidth: {
            type: String,
            required: false,
            default: 'min(800px, 90%)'
        }
    },
    data() {
        return {
            isModalVisible: false
        }
    },
    methods: {
        filterResult(search) {
            return this.selectOptions.filter(option => {
                return option.label.toLowerCase().indexOf(search.toLowerCase()) > -1;
            });
        },
        setResult(result) {
            if (this.allowMultiple) {
                if( ! this.currentValue) {
                    this.currentValue = [];
                }

                this.currentValue.push(result[this.valueProp]);
                this.search = '';
                this.results = this.filterResult(this.search);
            } else {
                this.currentValue = result[this.valueProp];
                this.search = result.label ? result.label : '';
                this.closeModal();
            }
        },
        /**
         * Open modal
         */
        openModal() {
            this.isModalVisible = true;
            // Focus the search field
            this.$nextTick(() => this.$refs.search.focus());
        },
        /**
         * Close modal
         */
        closeModal() {
            this.isModalVisible = false;
        },
    },
    created() {
        if (this.value !== null) {
            this.search = this.selectOptions.find(option => option[this.valueProp] === this.value).label;
        }
        // we trigger the filter result with empty string to show all options at first
        this.results = this.filterResult('');
    }
}, 'form/controls/ak-autocomplete-in-modal.html');